import { Box } from '@mui/material'
import styles from './WorkspaceTile.module.scss'
import { accentColor } from '@/services/workspaces/workspacePresets'
import { workspaceVisual } from '@/services/workspaces/workspaceVisual'

export default function WorkspaceTile({ workspace, active, onSelect }) {
  const color = accentColor(workspace.accent)
  const visual = workspaceVisual(workspace)
  return (
    <Box
      component="button"
      type="button"
      className={`${styles.tile} ${active ? styles.active : ''}`}
      sx={active ? { backgroundColor: color, borderColor: color } : undefined}
      aria-label={workspace.name}
      aria-current={active ? 'true' : undefined}
      onClick={() => onSelect(workspace.id)}
    >
      {visual.kind === 'emoji' ? (
        <span className={styles.glyph} aria-hidden>
          {visual.value}
        </span>
      ) : (
        <visual.Icon className={styles.icon} aria-hidden />
      )}
    </Box>
  )
}
